export const LOCAL = { 
  URL: 'http://localhost:8001/graphql',
  API_URL: 'http://localhost:8001', // ← Add this for comment generation API
  EXTENSION_ID: process.env.REACT_APP_NALAPOD_EXTENSION_ID ?? '',
}

export const DEVELOP = {
  URL: '/graphql',
  API_URL: '', // ← Empty string uses same domain in production
  EXTENSION_ID: process.env.REACT_APP_NALAPOD_EXTENSION_ID ?? '',
}